import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page" style={{ 
      padding: '20px', 
      maxWidth: '800px', 
      margin: '0 auto', 
      fontFamily: "'Inter', sans-serif",
      textAlign: 'center' // Center-align all text
    }}>
      {/* Back button at the top */}
      <div style={{ margin: '20px 0' }}>
        <Link to="/" style={{ 
          display: 'inline-block', 
          padding: '10px 20px', 
          backgroundColor: '#9CDAED', 
          color: 'black', 
          textDecoration: 'none', 
          borderRadius: '8px',
          fontWeight: 'bold'
        }}>
          Return to Home
        </Link>
      </div>
      
      <h1>Privacy Policy</h1>
      <p>Last Updated: April 23, 2025</p>
      
      <div style={{ textAlign: 'left' }}> {/* Keep content left-aligned for readability */}
        <h2>1. Introduction</h2>
        <p>Welcome to Links, an AI-powered math tutoring application. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service. Please read this Privacy Policy carefully. By accessing or using our service, you agree to the terms of this Privacy Policy.</p>
        
        <h2>2. Information We Collect</h2>
        <p>We may collect information about you in various ways, including:</p>
        <ul>
          <li><strong>Personal Information</strong>: Information that can be used to identify you, such as your name, email address, and in some cases, age or grade level.</li>
          <li><strong>Usage Data</strong>: Information on how you use the service, including problem-solving patterns, time spent on problems, and progress through different math topics.</li>
          <li><strong>Drawing Data</strong>: When you use our interactive canvas, we may collect the drawings you create to provide feedback and tutoring.</li>
          <li><strong>Audio Data</strong>: If you enable audio features, we may collect audio data to provide tutoring services.</li>
        </ul>
        
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Personalize your math learning experience</li>
          <li>Analyze how our service is used to improve functionality</li>
          <li>Communicate with you about your account and provide customer support</li>
          <li>Develop new features and tools</li>
        </ul>
        
        <h2>4. Data Security</h2>
        <p>We implement appropriate technical and organizational security measures to protect your personal information. Your passwords and authentication credentials are secured using Supabase authentication systems. However, no method of transmission over the Internet or electronic storage is 100% secure, so we cannot guarantee absolute security.</p>
        
        <h2>5. User Data Commitment</h2>
        <p><strong>We will never sell your personal data to third parties.</strong> Your privacy and trust are important to us, and we are committed to using your information solely for the purpose of providing and improving our tutoring service.</p>
        
        <h2>6. AI Model Usage</h2>
        <p>Our service uses artificial intelligence to provide tutoring. We may update or change our AI models at any time. While we implement security measures around our AI systems, we cannot guarantee protection against all potential exploits or jailbreaking attempts.</p>
        
        <h2>7. Children's Privacy</h2>
        <p>Our service may be used by children for educational purposes. We comply with applicable laws regarding children's privacy, including obtaining parental consent when required. We do not knowingly collect personal information from children under 13 without verifiable parental consent.</p>
        
        <h2>8. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top.</p>
        
        <h2>9. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at brockman.michael2003@gmail.com.</p>
      </div>
      
      {/* Back button at the bottom */}
      <div style={{ marginTop: '30px' }}>
        <Link to="/" style={{ 
          display: 'inline-block', 
          padding: '10px 20px', 
          backgroundColor: '#9CDAED', 
          color: 'black', 
          textDecoration: 'none', 
          borderRadius: '8px',
          fontWeight: 'bold'
        }}>
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;